export class HrPayGroupEmployeeSubtypeKey {
    private static readonly keyPrefix = 'hrPayGroupEmployeeSubtype';
    public static pageHeader = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.pageHeader`;
    public static shortPageHeader = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.shortPageHeader`;
    public static employeeTypeUuid = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.employeeTypeUuid`;
    public static employeeSubtypeUuid = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.employeeSubtypeUuid`;
    public static employeeSubtypeWageGroup = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.employeeSubtypeWageGroup`;
    public static workAreaInfoTrId = `${HrPayGroupEmployeeSubtypeKey.keyPrefix}.workAreaInfoTrId`;
}
